// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msess-head {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}

.msess-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 4px;
    color: var(--md-ink, #0f172a);
}

.msess-sub {
    margin: 0;
    color: var(--md-muted, #64748b);
    font-size: 14px;
    max-width: 42rem;
}

.msess-head-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.msess-subtabs {
    gap: 8px;
    margin-bottom: 16px;
}

.msess-subtabs .nav-link {
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    background: #f1f5f9;
}

.msess-subtabs .nav-link.active {
    background: #1d4ed8;
    color: #fff;
}

.msess-banner {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    color: #1e3a8a;
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 14px;
    margin-bottom: 16px;
}

.msess-avail-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
}

.msess-grid-title {
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 2px;
    color: var(--md-ink, #0f172a);
}

.msess-tz {
    margin: 0;
    font-size: 12px;
    color: var(--md-muted, #64748b);
}

.msess-duration {
    min-width: 180px;
}

.msess-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    list-style: none;
    padding: 0;
    margin: 0 0 12px;
    font-size: 13px;
    color: #334155;
}

.msess-swatch {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 3px;
    margin-right: 6px;
    vertical-align: -1px;
    border: 1px solid #cbd5e1;
}

.msess-swatch.is-available {
    background: #1d4ed8;
    border-color: #1d4ed8;
}

.msess-swatch.is-booked {
    background: #15803d;
    border-color: #15803d;
}

.msess-swatch.is-unavailable {
    background: #fff;
}

.msess-grid {
    background: #fff;
    border: 1px solid var(--md-line, #e2e8f0);
    border-radius: 12px;
    overflow: hidden;
}

.msess-grid-row {
    display: grid;
    /* Time column + Mon–Sun (7 days). Using 5 caused Sat/Sun to wrap under Mon/Tue. */
    grid-template-columns: 96px repeat(7, minmax(0, 1fr));
    border-top: 1px solid #f1f5f9;
}

.msess-grid-row:first-child {
    border-top: 0;
}

.msess-grid-head {
    background: #f8fafc;
}

.msess-day,
.msess-time {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    padding: 10px 8px;
    display: flex;
    align-items: center;
}

.msess-day {
    justify-content: center;
}

.msess-cell {
    min-height: 42px;
    border: 0;
    border-left: 1px solid #f1f5f9;
    background: #fff;
    color: #94a3b8;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
}

.msess-cell.is-unavailable {
    background: #fff;
    color: #94a3b8;
    box-shadow: inset 0 0 0 1px #e2e8f0;
}

.msess-cell.is-unavailable:hover:not(:disabled) {
    background: #f8fafc;
    color: #64748b;
}

.msess-cell.is-open {
    background: #1d4ed8;
    color: #fff;
    box-shadow: none;
}

.msess-cell.is-open:hover:not(:disabled) {
    background: #1e40af;
}

.msess-cell.is-open.is-booked {
    background: #15803d;
    color: #fff;
    cursor: default;
}

.msess-cell:disabled {
    cursor: not-allowed;
    opacity: 1;
}

.msess-list-card {
    background: #fff;
    border: 1px solid var(--md-line, #e2e8f0);
    border-radius: 12px;
    padding: 16px 18px;
}

.msess-upcoming-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.msess-upcoming-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid #f1f5f9;
}

.msess-upcoming-row:last-child {
    border-bottom: 0;
    padding-bottom: 0;
}

.msess-upcoming-when {
    margin: 0 0 4px;
    font-weight: 700;
    color: var(--md-ink, #0f172a);
}

.msess-upcoming-meta {
    margin: 0 0 4px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    color: var(--md-muted, #64748b);
    font-size: 13px;
}

.msess-upcoming-topic {
    margin: 0;
    color: #334155;
}

.msess-upcoming-agenda {
    margin: 4px 0 0;
    font-size: 13px;
    color: var(--md-muted, #64748b);
}

.msess-upcoming-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
}

.msess-muted {
    color: #94a3b8;
    font-size: 13px;
}

.msess-lunch {
    background: #f8fafc;
}

.msess-lunch-bar {
    grid-column: 2 / -1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #94a3b8;
    padding: 10px;
}

.msess-save-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-top: 14px;
}

.msess-save-error {
    margin: 0;
    color: #dc2626;
    font-size: 13px;
}

.msess-empty-card,
.msess-past {
    background: #fff;
    border: 1px solid var(--md-line, #e2e8f0);
    border-radius: 12px;
    padding: 20px;
}

.msess-empty {
    margin: 0;
    color: var(--md-muted, #64748b);
    font-size: 14px;
}

.msess-past-lead {
    font-size: 13px;
    color: var(--md-muted, #64748b);
    margin: 0 0 12px;
}

.msess-table {
    margin-bottom: 12px;
    font-size: 13px;
}

.msess-role-chip {
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    background: #f1f5f9;
    color: #334155;
    border-radius: 999px;
    padding: 2px 8px;
}

.msess-pager {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #64748b;
}

@media (max-width: 767px) {
    .msess-grid-row {
        grid-template-columns: 72px repeat(7, minmax(72px, 1fr));
    }

    .msess-grid {
        overflow-x: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentorSessions.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kFAAkF;IAClF,qDAAqD;IACrD,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,wDAAwD;IAC5D;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".msess-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.msess-title {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0 0 4px;\n    color: var(--md-ink, #0f172a);\n}\n\n.msess-sub {\n    margin: 0;\n    color: var(--md-muted, #64748b);\n    font-size: 14px;\n    max-width: 42rem;\n}\n\n.msess-head-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.msess-subtabs {\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.msess-subtabs .nav-link {\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #334155;\n    background: #f1f5f9;\n}\n\n.msess-subtabs .nav-link.active {\n    background: #1d4ed8;\n    color: #fff;\n}\n\n.msess-banner {\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    color: #1e3a8a;\n    border-radius: 10px;\n    padding: 12px 14px;\n    font-size: 14px;\n    margin-bottom: 16px;\n}\n\n.msess-avail-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 10px;\n}\n\n.msess-grid-title {\n    font-size: 16px;\n    font-weight: 700;\n    margin: 0 0 2px;\n    color: var(--md-ink, #0f172a);\n}\n\n.msess-tz {\n    margin: 0;\n    font-size: 12px;\n    color: var(--md-muted, #64748b);\n}\n\n.msess-duration {\n    min-width: 180px;\n}\n\n.msess-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    list-style: none;\n    padding: 0;\n    margin: 0 0 12px;\n    font-size: 13px;\n    color: #334155;\n}\n\n.msess-swatch {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border-radius: 3px;\n    margin-right: 6px;\n    vertical-align: -1px;\n    border: 1px solid #cbd5e1;\n}\n\n.msess-swatch.is-available {\n    background: #1d4ed8;\n    border-color: #1d4ed8;\n}\n\n.msess-swatch.is-booked {\n    background: #15803d;\n    border-color: #15803d;\n}\n\n.msess-swatch.is-unavailable {\n    background: #fff;\n}\n\n.msess-grid {\n    background: #fff;\n    border: 1px solid var(--md-line, #e2e8f0);\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.msess-grid-row {\n    display: grid;\n    /* Time column + Mon–Sun (7 days). Using 5 caused Sat/Sun to wrap under Mon/Tue. */\n    grid-template-columns: 96px repeat(7, minmax(0, 1fr));\n    border-top: 1px solid #f1f5f9;\n}\n\n.msess-grid-row:first-child {\n    border-top: 0;\n}\n\n.msess-grid-head {\n    background: #f8fafc;\n}\n\n.msess-day,\n.msess-time {\n    font-size: 12px;\n    font-weight: 600;\n    color: #475569;\n    padding: 10px 8px;\n    display: flex;\n    align-items: center;\n}\n\n.msess-day {\n    justify-content: center;\n}\n\n.msess-cell {\n    min-height: 42px;\n    border: 0;\n    border-left: 1px solid #f1f5f9;\n    background: #fff;\n    color: #94a3b8;\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.msess-cell.is-unavailable {\n    background: #fff;\n    color: #94a3b8;\n    box-shadow: inset 0 0 0 1px #e2e8f0;\n}\n\n.msess-cell.is-unavailable:hover:not(:disabled) {\n    background: #f8fafc;\n    color: #64748b;\n}\n\n.msess-cell.is-open {\n    background: #1d4ed8;\n    color: #fff;\n    box-shadow: none;\n}\n\n.msess-cell.is-open:hover:not(:disabled) {\n    background: #1e40af;\n}\n\n.msess-cell.is-open.is-booked {\n    background: #15803d;\n    color: #fff;\n    cursor: default;\n}\n\n.msess-cell:disabled {\n    cursor: not-allowed;\n    opacity: 1;\n}\n\n.msess-list-card {\n    background: #fff;\n    border: 1px solid var(--md-line, #e2e8f0);\n    border-radius: 12px;\n    padding: 16px 18px;\n}\n\n.msess-upcoming-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.msess-upcoming-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px 0;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.msess-upcoming-row:last-child {\n    border-bottom: 0;\n    padding-bottom: 0;\n}\n\n.msess-upcoming-when {\n    margin: 0 0 4px;\n    font-weight: 700;\n    color: var(--md-ink, #0f172a);\n}\n\n.msess-upcoming-meta {\n    margin: 0 0 4px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    color: var(--md-muted, #64748b);\n    font-size: 13px;\n}\n\n.msess-upcoming-topic {\n    margin: 0;\n    color: #334155;\n}\n\n.msess-upcoming-agenda {\n    margin: 4px 0 0;\n    font-size: 13px;\n    color: var(--md-muted, #64748b);\n}\n\n.msess-upcoming-actions {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 8px;\n}\n\n.msess-muted {\n    color: #94a3b8;\n    font-size: 13px;\n}\n\n.msess-lunch {\n    background: #f8fafc;\n}\n\n.msess-lunch-bar {\n    grid-column: 2 / -1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    color: #94a3b8;\n    padding: 10px;\n}\n\n.msess-save-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-top: 14px;\n}\n\n.msess-save-error {\n    margin: 0;\n    color: #dc2626;\n    font-size: 13px;\n}\n\n.msess-empty-card,\n.msess-past {\n    background: #fff;\n    border: 1px solid var(--md-line, #e2e8f0);\n    border-radius: 12px;\n    padding: 20px;\n}\n\n.msess-empty {\n    margin: 0;\n    color: var(--md-muted, #64748b);\n    font-size: 14px;\n}\n\n.msess-past-lead {\n    font-size: 13px;\n    color: var(--md-muted, #64748b);\n    margin: 0 0 12px;\n}\n\n.msess-table {\n    margin-bottom: 12px;\n    font-size: 13px;\n}\n\n.msess-role-chip {\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 600;\n    background: #f1f5f9;\n    color: #334155;\n    border-radius: 999px;\n    padding: 2px 8px;\n}\n\n.msess-pager {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: #64748b;\n}\n\n@media (max-width: 767px) {\n    .msess-grid-row {\n        grid-template-columns: 72px repeat(7, minmax(72px, 1fr));\n    }\n\n    .msess-grid {\n        overflow-x: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
